import { FooterWidgetWrapper } from "components/Footer";
import { Form } from "components/Forms";
import { Heading3, ImageLite, Paragraph } from "shared/components";

import styles from "./Footer002.module.scss";

export const Footer002 = ({ payload }) => {
  const title = payload?.title ?? "";
  const manager = payload?.manager ?? {};
  const formType = payload?.formType ?? {};
  const template = payload?.template ?? "dark";

  const { fullName, position, contactTitle, contactValue } = manager;

  return (
    <FooterWidgetWrapper className={styles[template]}>
      <div className={styles.content}>
        <Heading3 className={styles.title} color="dark">
          {title}
        </Heading3>
        <div className={styles.blocks}>
          <div className={styles.manager}>
            <ImageLite image={manager.preview} className={styles.image} />
            <div className={styles.info}>
              <Paragraph className={styles.name} color="dark" appearance="bold">
                {fullName}
              </Paragraph>
              <Paragraph className={styles.position} color="grey" uppercase>
                {position}
              </Paragraph>
              <Paragraph className={styles.label} color="grey" uppercase>
                {contactTitle}
              </Paragraph>
              <a href={`tel:${contactValue}`} className={styles.phone}>
                {contactValue}
              </a>
            </div>
          </div>
          <div className={styles.application}>
            <Form item={formType} />
          </div>
        </div>
      </div>
    </FooterWidgetWrapper>
  );
};

export default Footer002;
